import React from "react";
import styles from "../Assets/css/masterclass.module.css";
import clock from "../Assets/img/Masterclass/Icon ionic-md-time.png";
import calendar from "../Assets/img/Masterclass/Icon material-today-black.png";
import masterBanner from "../Assets/img/Masterclass/blogs.png";
import { NavLink } from "react-bootstrap";
import { useEffect } from "react";

const MasterClassComponent = ({
	topic,
	agenda,
	start_time,
	join_url,
	end_time,
	registration_url,
	webinar_id,
	image,
}) => {
	const date = new Date(start_time);
	const year = date.getFullYear();
	const month = date.getMonth() + 1;
	const dt = date.getDate();
	const time =
		date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
	if (dt < 10) {
		dt = "0" + dt;
	}
	var months = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];
	const newDate = `${dt} ${months[month - 1]} ${year}`;
	//   function ConvertNumberToTwoDigitString(n) {
	//     return n > 9 ? "" + n : "0" + n;
	//   }
	//   var my_time = new Date(start_time);
	//   var get_time =
	//     ConvertNumberToTwoDigitString(my_time.getUTCHours()) +
	//     ":" +
	//     ConvertNumberToTwoDigitString(my_time.getUTCMinutes());

	// Returns the given integer as a string and with 2 digits
	// For example: 7 --> "07"

	function formatAMPM(date) {
		var mytime = new Date(date);
		var hours = mytime.getHours();
		var minutes = mytime.getMinutes();
		var ampm = hours >= 12 ? "pm" : "am";
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		minutes = minutes < 10 ? "0" + minutes : minutes;
		var strTime = hours + ":" + minutes + " " + ampm;
		return strTime;
	}
	var current_time;
	useEffect(() => {
		current_time = new Date().toISOString();
	}, [current_time]);

	return (
		<>
			<div
				style={{
					paddingRight: "2%",
					paddingTop: "3%",
					paddingBottom: "3%",
					height: "fit-content",
					// boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
				}}
				className={`col-xl-5 col-lg-4 col-md-6 mx-4 my-2 `}
			>
				<div className={`card ${styles.cardsArchivedJ}`}>
					<img
						style={{
							height: "100px",
							width: "100%",
							borderRadius: "10px 10px 0px 0px",
						}}
						//   className={`card-img-top ${styles.cardsArchivedJ}`}
						src={image}
						alt="Card image cap"
					/>
					<div className={styles.cardBody}>
						<h5 className="card-title">{topic}</h5>
						<p style={{ width: "60%" }} className="card-text">
							{agenda}
						</p>

						<div className={`d-flex ${styles.archivedButtonJ}`}>
							<div
								className={`d-flex ${styles.archivedIconJ} mt-4`}
							>
								<div style={{ marginRight: "1.5vw" }}>
									<p className="cal-J">
										<img src={calendar} alt="" />
										{newDate}
									</p>
								</div>
								<div className="mr-5">
									<p className="clock-J">
										<img src={clock} alt="" />
										{formatAMPM(start_time)}
									</p>
								</div>
							</div>

							<div className=" mt-4">
								<div className="mb-2">
									<a
										style={{
											color: "#212529",
										}}
										className={`${styles.btn} ${styles.btnLight} shadow `}
										href={`/masterclasspage/?webinar=${webinar_id}`}
										exact
									>
										AUDIT
									</a>
								</div>
								<p
									style={{
										textAlign: "center",
										fontSize: " 10px",
										fontWeight: "900",
									}}
								>
									5673 have Enrolled
								</p>
							</div>
							<p
								style={{
									textAlign: "center",
									fontSize: " 10px",
									fontFamily: "Poppins-Black",
								}}
							>
								5673 have Enrolled
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default MasterClassComponent;
